import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

export default {
  success,
  error,
};
function success(msg) {
  NotificationManager.success(msg || `Congratulation !!!`, 'Success', 3000);
}
function error(msg) {
  NotificationManager.error(msg || 'Something went wrong', 'Oops', 3000);
}
